import React from "react";
import { Container } from "./styles";
import FormChangePassword from "../../components/Forms/FormChangePassword";

export default function ChangePassword() {
  return (
    <Container>
      <FormChangePassword />
    </Container>
  );
}
